const $ = require('jQuery');

const UpcomingEvents = function (el) {
  this.$el = $(el);
  this.$featuresBody = this.$el.find('.js-features-body');
  this.$featuresHeroContent = this.$el.find('.js-features-hero-content');
  this.$searchResults = this.$el.find('.js-search-results');
  this.$termHeroContent = this.$el.find('.js-term-hero-content');
  this.$termPageTitle = this.$el.find('.js-term-page-title');
  
  this.overrideViewAllButtonAction();

  window.onpopstate = this.onpopstate.bind(this);

  this.showInitialPage();
}

UpcomingEvents.prototype.showInitialPage = function () {
    const term = this.getTermQueryString();

    if (term) {
        const termPageTitle = this.getTQueryString();
        this.showTermPage(termPageTitle, term);
    } else {
        this.showFeatures();
    }
}

UpcomingEvents.prototype.deleteTermQueryString = function () {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  searchParams.delete('term');
  searchParams.delete('t');

  const state = url.pathname + url.search + url.hash;

  window.history.replaceState(null, window.document.title, state);
}

UpcomingEvents.prototype.closeTermPage = function () {
  this.showFeatures();
  this.deleteTermQueryString();
}

UpcomingEvents.prototype.onpopstate = function () {
  this.closeTermPage();
}

UpcomingEvents.prototype.scrollToTopOfPage = function () {
  const $body = $("html, body");
  $body.stop().animate({scrollTop:0}, 500, 'swing', () => {});
}

UpcomingEvents.prototype.showFeatures = function () {
  this.hideAllContent();
  this.$featuresBody.removeClass('hide');
  this.$featuresHeroContent.removeClass('hide');
}

UpcomingEvents.prototype.showSearchResults = function () {
  this.hideAllContent();
  this.$searchResults.removeClass('hide');
}

UpcomingEvents.prototype.changeTermPageTitle = function (title) {
  this.$termPageTitle.text(title);
}

UpcomingEvents.prototype.showResourcesForTerm = function (term) {
  const $termPageResources = $('.js-search-result');

  $termPageResources.addClass('hide');

  const isRecentsPage = term === 'recent';

  if (isRecentsPage) {
    for (let i = 0; i < $termPageResources.length && i < 40; i++) {
      $($termPageResources[i]).removeClass('hide')
    }
    return;
  }

  $termPageResources.each(function () {
    const $resource = $(this);
    const terms = $resource.attr('data-terms');
    const termRegexp = new RegExp(term, 'i');

    const belongsOnThisTermPage = termRegexp.test(terms);

    if (belongsOnThisTermPage) {
      $resource.removeClass('hide');
    }
  });
}

UpcomingEvents.prototype.getValueFromQueryString = function (key) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const value = searchParams.get(key);
  return value;
}

UpcomingEvents.prototype.getTermQueryString = function () {
  return this.getValueFromQueryString('term');
}

UpcomingEvents.prototype.getTQueryString = function () {
  return this.getValueFromQueryString('t');
}

UpcomingEvents.prototype.showTermPage = function (title, term) {
  this.hideAllContent();
  this.$termHeroContent.removeClass('hide');
  this.$searchResults.removeClass('hide');
  this.changeTermPageTitle(title);
  this.showResourcesForTerm(term);
  this.setTermPageQueryString(term, title);
  this.scrollToTopOfPage();
}

UpcomingEvents.prototype.hideAllContent = function () {
  this.$featuresBody.addClass('hide');
  this.$featuresHeroContent.addClass('hide');
  this.$searchResults.addClass('hide');
  this.$termHeroContent.addClass('hide');
}

UpcomingEvents.prototype.overrideViewAllButtonAction = function () {
  const $viewAllLinks = this.$featuresBody.find('.itbl-b-layout__heading a');

  const boundOnClickViewAll = this.onClickViewAll.bind(this);

  $viewAllLinks.each(function () {
    const $link = $(this);
    const href = $link.attr('href');

    // Overrides only in page links
    const shouldOverride = /^\?/.test(href);

    if (shouldOverride) {
      $link.on('click', boundOnClickViewAll);
    }
  });
}

UpcomingEvents.prototype.onClickViewAll = function (e) {
  e.preventDefault();

  const $link = $(e.target);
  const href = $link.attr('href');
  const url = window.location.href;
  const urlWithoutQueryString = url.split('?')[0];
  const urlWithNewQueryString = urlWithoutQueryString + href;
  const targetUrl = new URL(urlWithNewQueryString);
  const queryParams = targetUrl.searchParams;
  const term = queryParams.get('term');
  const title = queryParams.get('t');

  this.showTermPage(title, term);
}

UpcomingEvents.prototype.setTermPageQueryString = function (term, title) {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  if (term === '') {
    searchParams.delete('term');
    searchParams.delete('t');
  } else {
    searchParams.set('term', term);
    searchParams.set('t', title);
  }

  const state = url.pathname + url.search + url.hash;

  window.history.pushState(null, window.document.title, state);
}

UpcomingEvents.prototype.isOnTermPage = function () {
  const term = this.getTermQueryString();
  return !!term;
}

UpcomingEvents.prototype.closeSearchPage = function () {
  const isOnTermPage = this.isOnTermPage()

  if (isOnTermPage) {
    const term = this.getTermQueryString();
    const title = this.getTQueryString();
    this.showTermPage(title, term);
  } else {
    this.showFeatures();
  }
}

$(document).ready(function () {
  $('.js-upcoming-events-page').each(function () {
    new UpcomingEvents(this);
  });
});
